const MainPlugin = {

  install(Vue, options) {
    Vue.prototype.$logged = function() {
      var now = Math.floor(Date.now() / 1000);
      var currentToken = localStorage.getItem('token');
      var currentTokenExpiration = parseInt(localStorage.getItem('tokenExpiration'));
      if ((!currentToken) || (!currentTokenExpiration)) {
        currentToken = '';
        currentTokenExpiration = 0;
      }
      if (currentTokenExpiration + globalConstants.tokenExpireTime < now) {
        if (this.$router.history.current.path != '/login') {
          localStorage.setItem('currentPage', this.$router.history.current.path);
        };
        console.log('token expired', currentTokenExpiration, now);
        this.$root.logged = false;
        this.$clearLogin();
        return false;
      }
      this.$root.logged = true;
      return true;

    }

    Vue.prototype.$clearLogin = function() {
      console.log('auth cleared');
      this.$root.logged = false;
      localStorage.setItem('token', '');
      localStorage.setItem('tokenExpiration', 0);
      localStorage.setItem('group', '');
      if (!this.$router.history.current.path != '/login') // порехедим на страницу входа, если еще не там
        this.$router.push('/login');
    }
    Vue.prototype.$saveLogin = function(token, tokenExpiration, group) {
      console.log('auth filled');
      localStorage.setItem('token', token);
      localStorage.setItem('tokenExpiration', tokenExpiration);
      localStorage.setItem('group', group);
    }

    Vue.prototype.$API = function(controller, func, parameters, callback, errorFunction) {
      //выход, если не авторизованы
      if (!this.$logged()) {
        this.$clearLogin();
        errorFunction('auth_failed');
        return false;
      }
      var cont = this;

      var url = globalConstants.backendUrl + '?controller=' + controller + '&function=' + func;

      var data = new FormData()
      // токен для всех запросов
      data.append('token', localStorage.getItem('token'))
      //данные запроса
      for (var prop in parameters) {
        data.append(prop, parameters[prop]);
      }
      axios.post(url, data)
        .then(function(response) {
          // handle success
          // console.log(response);
          if ((typeof response.data.result !== 'undefined') && (response.data.result === 'ok')) {
            callback(response.data.data); //запускаем коллбкэ, передавая данные
          } else {
            if ((typeof response.data.result !== 'undefined') && (typeof response.data.data.text !== 'undefined') && (
                (response.data.data.text == 'bad_token') || (response.data.data.text == 'no_user')
              ))
              cont.$clearLogin();
            throw "no_success_api_message";
          }
        })
        .catch(function(error) {
          // handle error
          console.log(error);
          errorFunction(error);
        })
        .finally(function() {
          // always executed
        });



    }
    Vue.prototype.$auth = function(username, password, authorized, failed) {
      var cont = this;

      var data = new FormData()

      data.append('user', username)
      data.append('password', password)
      axios.post(globalConstants.backendUrl + '?controller=users&function=login', data)
        .then(function(response) {
          // handle success
          console.log(response);

          if ((typeof response.data.result !== 'undefined') && (response.data.result === 'ok')) {
            var now = Math.floor(Date.now() / 1000);
            console.log('good', response.data.data.group, now + globalConstants.tokenExpireTime);

            cont.$saveLogin(response.data.token, now, response.data.data.group);

            authorized();
          } else {
            if ((typeof response.data.result !== 'undefined') && (typeof response.data.data.text !== 'undefined') && (
                (response.data.data.text == 'bad_token') || (response.data.data.text == 'no_user')
              ))
              cont.$clearLogin();
            throw "no_success_auth_message";
          }


        })
        .catch(function(error) {
          // handle error
          console.log(error);
          cont.$clearLogin();
          failed(error);
        })
        .finally(function() {
          // always executed
        });

    }
    Vue.prototype.$getColorTemp = function(value) {

      //value from 0 to 1
      //value = 100 - value;
      var r = (value < 50 ? 200 : Math.floor(200 - (value * 2 - 100) * 200 / 100)).toString(16);
      var g = (value > 50 ? 200 : Math.floor((value * 2) * 200 / 100)).toString(16);
      if (r.length == 1) r = "0" + r;
      if (g.length == 1) g = "0" + g;
      var color = "#" + r + g + "00";
      //console.log(value, color);
      return color;
    }
    // We call Vue.mixin() here to inject functionality into all components.
    Vue.mixin({
      data: function() {
        return {

        }
      },

      mounted() {
        if (this.$router.history.current.path != '/login') {
          localStorage.setItem('currentPage', this.$router.history.current.path);
        };
        console.log('плагин mounted');
      }
    });
  }
};

export default MainPlugin;


// WEBPACK FOOTER //
// ./src/app/js/plugins/main.js